import { FileDownloadService } from "@topline/services/fileDownloadService";

(function (module) {
    module.service("marketContentReportService", [
        FileDownloadService.componentName,
        function (this: $TSFixMe, fileDownloadService: FileDownloadService) {
            var service = this;

            service.downloadReport = function (parameters: $TSFixMe) {
                fileDownloadService.downloadFile("/api/report/market/content/", "Markets", parameters);
            };
        }
    ]);
})(angular.module("topline.modules"));
